export default __webpack_public_path__ + "static/bm-signature-large-d3dad06cf5f3408083e2222f06b533de.png";